import * as actionTypes from "./actionTypes";
import axios from "../axios-order";

export const fetchContriesSuccess = (contries) => {
 
  return {
    type: actionTypes.FETCH_COUNTRIES_SUCCESS,
    contries: contries,
  };
};
export const fetchContries = () => {
  return (dispatch) => {
    axios
      .get("/site-contents")
      .then((response) => {       
        dispatch(fetchContriesSuccess(response.data));
      })
      .catch((err) => {
        dispatch(fetchContriesFail(err));
      });
  };
};
export const fetchContriesFail = () => {
  return {
    type: actionTypes.FETCH_COUNTRIES_FAIL,
  };
};

export const fetchImagesSuccess = (bannerImages)=>{
  return{
      type:actionTypes.FETCH_BANNERIMAGES_SUCCESS,
      bannerImages : bannerImages
  }
}
export const fetchImagesFail = ()=>{
  return{
      type:actionTypes.FETCH_BANNERIMAGES_FAIL
  }
}
export const fetchImages = ()=>{
  return (dispatch) =>{
    axios
    .get("/banner-images")
    .then((response) => {
      dispatch(fetchImagesSuccess(response.data.data));
    })
    .catch((err) => {
      dispatch(fetchImagesFail());
    });
  }
}

